import styled from 'styled-components'

import { TradePositionDetailsHeader } from './trade-position-details-header'
import { TradePositionDetailsTable } from './trade-position-details-table'

import type { AggregatedPositionModel } from '@root/entities/position'

type Props = {
  position: AggregatedPositionModel
}

export const TradePositionDetails: React.FC<Props> = ({ position }) => {
  return (
    <Root>
      <TradePositionDetailsHeader position={position} />
      <TradePositionDetailsTable position={position} />
    </Root>
  )
}

const Root = styled.div`
  padding: 25px;
  gap: 30px;
  display: grid;
  grid-template-rows: auto 1fr;
  overflow-y: auto;
  overflow-x: hidden;

  background: var(--dark-grey-60, rgba(25, 25, 25, 0.6));
`
